import { Selection, DefaultButton, MessageBar, MessageBarType, PrimaryButton, EventGroup, SelectionMode, ITextStyles, Text, mergeStyleSets, IconButton } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { IAutocompleteField, IDateTimeField, IField, INumberField, IProtocol, ITextField } from '../../../../shared/interfaces';
import { RootState } from '../../../../store';
import SearchAsStreamComponentBase from '../../../Ricerca/SearchAsStreamComponentBase';
import protocolReferencesSercice from '../../../../services/protocolReferences.service';
import ErrorUtilities from '../../../../shared/Utilities/errorUtilities';
import RippleLoader from '../../../Loader/RippleLoader/RippleLoader';
import { Search_QueryOperator } from '../../../../shared/enums';


const classNames = mergeStyleSets({
    panelLayer:
    {
        zIndex: 1000000,
        position: "fixed",
        overflow: 'hidden',
        height: '100%',
        inset: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.4)'
    },
    panelContainer: {
        overflow: 'hidden',
        position: "fixed",
        width: "900px",
        maxWidth: '100vw',
        height: '100%',
        right: 0,
        backgroundColor: 'rgba(255, 255, 255)',
        boxShadow: ' rgba(0, 0, 0, 0.22) 0px 25.6px 57.6px 0px, rgba(0, 0, 0, 0.18) 0px 4.8px 14.4px 0px',
        padding: 0,
        display: 'flex',
        flexFlow: 'column',
        animationName: 'css-57, css-65',
        animationDuration: '0.367s',
        animationTimingFunction: 'cubic-bezier(0.1, 0.9, 0.2, 1)',
        animationFillMode: 'both'


    } as React.CSSProperties,
    panelNavigation: {
        padding: '0 24px 24px',
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        '& button': {
            color: 'inherit !important',
        },

    } as React.CSSProperties,
    panelTitle: {
    },
    panelContent: {
        padding: '0 24px 0'
    },
    panelFooter: {
        padding: 24,
    } as React.CSSProperties
});

const textStyles: Partial<ITextStyles> = {
    root: {
        display: 'block',
        marginTop: '18px'
    }
}


/// ATTENZIONE la ricerca CAML non è testata per i campi lookup e NON è implementata per i campi user
const initialFields: IField[] = [
    {
        decimals: 0,
        percentage: false,
        displayName: "Anno",
        internalName: "Anno",
        sharepointType: "Number",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    } as INumberField,
    {
        decimals: 0,
        percentage: false,
        displayName: "Numero protocollo",
        internalName: "NumeroProtocollo",
        sharepointType: "Number",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    } as INumberField,
    {
        maxLength: 0,
        displayName: "Oggetto protocollo",
        internalName: "OggettoProtocollo",
        sharepointType: "Text",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false

    } as ITextField,
    {
        dateOnly: true,
        displayName: "Data protocollo",
        internalName: "DataProtocollo",
        sharepointType: "DateTime",
        controlType: "calendar",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        valid: false,
        touched: false,
        rangeMode: true

    } as IDateTimeField

    /// ATTENZIONE la ricerca CAML non è testata per i campi lookup e NON è implementata per i campi user

];

const staticFilter = [
    {
        internalName: "StatoProtocollo",
        internalValue: ["Protocollato"],
        search_queryOperator: Search_QueryOperator.Equals
    } as Partial<IField>
]

export interface AddProtocolReferencesPanelProps {
    loading?: boolean
    extraCssClass?: string
    addProtocolReferencesPanelIsOpen: boolean
    onAddProtocolReferenceSubmit: () => void
    onAddProtocolReferenceDismiss: () => void

}

type Props = AddProtocolReferencesPanelProps & RouteComponentProps

const AddProtocolReferencesPanel: React.FunctionComponent<Props> = (props) => {

    let [panelIsOpen, { setTrue: openAddProtocolReferencesPanel, setFalse: dismissAddProtocolReferencesPanel }] = useBoolean(props.addProtocolReferencesPanelIsOpen);

    let [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    let [messageBarType, setMessageBarType] = useState<MessageBarType>(MessageBarType.info)
    let [messageBarText, setMessageBarText] = useState<string>('')


    let [addProtocolReferencesBtnEnable, { setTrue: enableAddProtocolReferencesBtn, setFalse: disableAddProtocolReferencesBtn }] = useBoolean(false);
    let [addProtocolReferencesBtnText, setAddProtocolReferencesBtnText] = useState<string>('Aggiungi riferimento')


    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);

    const selectCurrentProtocol = (state: RootState) => state.appNavigationReducer.protocol
    const currentProtocol = useSelector(selectCurrentProtocol);

    let [actionsLoader, { setTrue: showActionsLoader, setFalse: hideActionsLoader }] = useBoolean(false);


    const [protocolReferencesSelection, setProtocolReferencesSelection] = useState<Selection>(new Selection({
        onSelectionChanged: () => { }
    }));

    useEffect(() => {
        const events = new EventGroup(undefined);
        events.on(protocolReferencesSelection, 'change', (ev) => {
            const selectedProtocolReferences = protocolReferencesSelection.getSelection() as IProtocol[];
            if (selectedProtocolReferences.length == 0) {
                disableAddProtocolReferencesBtn();
                setAddProtocolReferencesBtnText('Aggiungi riferimento');
            }
            // da inserire se si passa al multi select
            //if (selectedProtocolReferences.length > 1) {
            //    enableAddProtocolReferencesBtn();
            //    setAddProtocolReferencesBtnText('Aggiungi riferimenti');
            //}
            else {
                enableAddProtocolReferencesBtn();
                setAddProtocolReferencesBtnText('Aggiungi riferimento');
            }
        });

        return () => {
            // Anything in here is fired on component unmount.
            events.dispose();
        }


    }, []);


    const addProtocolReferencesPanelSubmit = () => {
        showActionsLoader();
        const selectedProtocolReference = protocolReferencesSelection.getSelection()[0] as IProtocol;
        protocolReferencesSercice.createReference(currentAoo!.id, currentUor!.id!, currentProtocol!.id!, selectedProtocolReference.id!)
            .then(result => {
                props.onAddProtocolReferenceSubmit();
            },
                error => {

                    let myArgumentException = ErrorUtilities.GetMyArgumentExceptionFromError(error);

                    if (myArgumentException && myArgumentException.showMessageInClientApp) {
                        setMessageBarType(MessageBarType.warning);
                        setMessageBarText(myArgumentException.message);
                    }
                    else {
                        setMessageBarType(MessageBarType.error);
                        setMessageBarText("Errore nella creazione del riferimento");

                    }
                    showMessageBar();
                }
            )
            .finally(() => {
                hideActionsLoader();
            });
    }

    const addProtocolReferencesPanelDismiss = () => {
        props.onAddProtocolReferenceDismiss();
    }
    const stopPropagation = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

    }

    return (
        <React.Fragment>
            <div className={`loader opacity ${actionsLoader ? "active" : ""}`} style={{ zIndex: 999999999999 }} >
                <RippleLoader text='Operazione in corso' />
            </div>

            {
                panelIsOpen &&
                <div className={classNames.panelLayer} onClick={addProtocolReferencesPanelDismiss} >
                    <div className={classNames.panelContainer} onClick={stopPropagation} >
                        {
                            messageBarIsVisible &&
                            <MessageBar
                                messageBarType={messageBarType}
                                isMultiline={false}
                                onDismiss={dismissMessageBar}
                                dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                        }

                        <div className={classNames.panelNavigation}>
                            <Text className={classNames.panelTitle} variant={'xLarge'} styles={textStyles}>Protocolli</Text>
                            <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancel" ariaLabel="Cancel" onClick={addProtocolReferencesPanelDismiss} />
                        </div>
                        <SearchAsStreamComponentBase
                            cssClassName={classNames.panelContent}
                            searchFormFields={initialFields}
                            staticFilter={staticFilter}
                            protocolReferencesSelection={protocolReferencesSelection}
                            selectionMode={SelectionMode.single}

                        />


                        <div className={classNames.panelFooter} >
                            <PrimaryButton
                                styles={{ root: { marginRight: 8 } }}
                                text={addProtocolReferencesBtnText}
                                onClick={addProtocolReferencesPanelSubmit}
                                disabled={!addProtocolReferencesBtnEnable}

                            />
                            <DefaultButton
                                onClick={addProtocolReferencesPanelDismiss}
                                text="Annulla"
                            />
                        </div>
                    </div>

                </div>
            }

        </React.Fragment>
    );
}

export default AddProtocolReferencesPanel;
